import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/OutputReports'
import context from '@/context'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import { Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import ReportAttachments from '@/components/reporting/reportAttachments'
import LoadingIndicator from '@/components/LoadingIndicator'
import Name from '@/components/Name'
import ErrorButton from '@/components/ErrorButton'
import ErrorBoundary from '@/components/ErrorBoundary'
import { OutputReportTable } from './outputReportTable'
import { ReportSubmissionTitle } from '@/components/reporting/submissions/reportSubmissionTitle'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import getEnumTranslation from '@/enums/enums'
import { OutputReportGroupState } from '@/enums/outputReportGroupState'

@localized()
class OutputReportDetail extends React.Component {
  constructor (props) {
    super(props)
    this.getParentId = this.getParentId.bind(this)
    this.goBack = this.goBack.bind(this)
  }

  getReportId () {
    return this.props.match.params.id
  }
  getParentId () {
    return this.props.match.params.parentId
  }
  getBackUrl () {
    return `/output-report-groups/${this.getParentId()}/output-reports`
  }
  goBack () {
    const url = this.getBackUrl()
    this.props.history.push(url)
  }
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.getReportId() !== prevProps.match.params.id) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.getReportId(), this.getParentId())
  }

  renderGeneralBox (outputReport) {
    if (outputReport === null) {
      return (
        <WhiteBox backUrl='/' header='Reporting.General'>
          <ErrorButton className='white-box-center' onClick={() => this.reload()} />
        </WhiteBox>
      )
    }

    const state = getEnumTranslation({
      localize: this.props.localize,
      enumName: OutputReportGroupState.enumName,
      value: outputReport.outputReportState
    })

    return (
      <WhiteBox header='Reporting.General'>
        <Row>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.Name' /></InfoLabel>
              <InfoContent><Name data={outputReport} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportTemplateName' /></InfoLabel>
              <InfoContent><Name data={outputReport.reportTemplateVersion} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel>State</InfoLabel>
              <InfoContent>{state}</InfoContent>
            </InfoRow>
          </Col>
        </Row>
      </WhiteBox>
    )
  }
  renderBody () {
    const { outputReports, addAttachments, removeAttachments } = this.props

    if (outputReports.fetching === true) { return (<LoadingIndicator />) }
    const submissionId = this.getReportId()
    return (
      <React.Fragment>
        <WhiteBox>
          <Row>
            <Col sm='12'>
              <ErrorBoundary>
                <Resx render={(x) => <OutputReportTable
                  isRtl={x.rtl}
                  isLoading={outputReports.fetching}
                  outputReport={outputReports.outputReport}
                  cellMetadata={outputReports.cellMetadata}
                  sourceHeaders={outputReports.sourceHeaders}
                  sourceRowHeaders={outputReports.sourceRowHeaders}
                  sourceData={outputReports.sourceData}
                  key={outputReports.key}
                  rowFilter={outputReports.rowFilter}
                  readOnly />}
                />
              </ErrorBoundary>
            </Col>
          </Row>
        </WhiteBox>
        <Row>
          <Col sm='12'>
            <ErrorBoundary>
              <ReportAttachments
                key={outputReports.attachmentsKey}
                dataSource={() => context.api.outputReportService.getAttachments(submissionId)}
                downloadAction={context.api.outputReportService.download}
                parentId={submissionId}
                addAttachments={addAttachments}
                removeAttachment={id => removeAttachments({ entityId: submissionId, fileIds: [id] })}
                adding={outputReports.adding} />
            </ErrorBoundary>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { outputReports } = this.props
    if (outputReports.fetching === true) { return (<LoadingIndicator />) }

    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={this.getBackUrl()}>
            <Resx name='Reporting.ReportSubmissionDetailTitle' /> <ReportSubmissionTitle reportSubmission={this.props.outputReports.outputReport} />
          </MainTopTitle>
        </MainTop>
        {this.renderGeneralBox(outputReports.outputReport)}
        <MainBody transparent>
          {this.renderBody()}
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    outputReports: state.outputReports,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  addAttachments: actionCreators.addAttachments,
  removeAttachments: actionCreators.removeAttachments
}

export default connect(mapStateToProps, mapDispatchToProps)(OutputReportDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReports/outputReportDetail.js